/**
 * Duftfinder – Quiz-Logik (Theme).
 *
 * Drei Fragen (Duft → Seele → Körper). Antwortwerte = Cluster-Titel, identisch
 * mit den Shopify-Metafeldern custom.duftfinder_duft/-seele/-koerper (Quelle:
 * scripts/duftfinder_clusters.py, SSOT). Produktdaten kommen live aus der
 * Section (#duftfinder-data, von sections/duftfinder.liquid gerendert).
 *
 * Ergebnis-Karten: die Section rendert jede Quiz-Karte als echte Standard-
 * Produktkarte (snippets/produkt-karte.liquid) in den versteckten Vorrat
 * #duftfinder-pool, in derselben Reihenfolge wie #duftfinder-data. Die Treffer
 * werden ins Ergebnis-Raster verschoben (nicht kopiert) und beim Neustart
 * zurückgelegt — die Warenkorb-Formulare behalten so ihre Handler aus main.js.
 *
 * Matching: weiches, gewichtetes Scoring (kein harter Filter) → es gibt immer
 * eine Top-Liste. Konzept/Begründung: docs/store-setup/duftfinder.md
 */
(function () {
  'use strict';

  // ── Quiz-Schritte ────────────────────────────────────────────────────────
  // value = exakter Cluster-Titel (matcht die Metafeld-Werte). Texte fix (SSOT).
  const QUIZ_STEPS = [
    {
      id: 'duft',
      frage: 'Welcher Duft spricht dich an?',
      subtitle: 'Folge einfach deiner Nase.',
      optionen: [
        { value: 'Frisch & Klar',   label: 'Frisch & Klar',   emoji: '🍃', beschreibung: 'Spritzig und kühl, belebend wie ein tiefer Atemzug' },
        { value: 'Kräuter & Grün',  label: 'Krautig & Grün',  emoji: '🌿', beschreibung: 'Aromatisch und lebendig wie eine Sommerwiese nach dem Regen' },
        { value: 'Würzig & Warm',   label: 'Würzig & Warm',   emoji: '🌶️', beschreibung: 'Vollmundig und umhüllend, mit viel Tiefe und Charakter' },
        { value: 'Blumig & Zart',   label: 'Blumig & Zart',   emoji: '🌸', beschreibung: 'Floral, weich und fein für die leise, romantische Seite' },
        { value: 'Süss & Fruchtig', label: 'Süss & Fruchtig', emoji: '🍯', beschreibung: 'Hell, verspielt und leicht wie pure Lebensfreude' },
        { value: 'Holzig & Harzig', label: 'Holzig & Harzig', emoji: '🪵', beschreibung: 'Erdig, balsamisch und behaglich wie ein Spaziergang durch den Wald' }
      ]
    },
    {
      id: 'seele',
      frage: 'Wie möchtest du dich fühlen?',
      subtitle: 'Was tut dir gerade gut?',
      optionen: [
        { value: 'Ruhe & Loslassen',        label: 'Ruhig & entspannt',       emoji: '🌙', beschreibung: 'Abschalten, loslassen und sanft zur Stille finden' },
        { value: 'Balance & Erdung',        label: 'Geerdet & gelassen',      emoji: '⚖️', beschreibung: 'Ganz bei sich ankommen, im Gleichgewicht mit sich selbst' },
        { value: 'Leichtigkeit & Stimmung', label: 'Heiter & beschwingt',     emoji: '☀️', beschreibung: 'Gute Laune, Zuversicht und Sonne im Gemüt' },
        { value: 'Energie & Antrieb',       label: 'Wach & voller Energie',   emoji: '⚡', beschreibung: 'Mit neuem Schwung, Tatendrang und Lust loszulegen' },
        { value: 'Klarheit & Frische',      label: 'Erfrischt & klar',        emoji: '💧', beschreibung: 'Den Kopf frei bekommen und unbeschwert denken' },
        { value: 'Wärme & Sinnlichkeit',    label: 'Warm & geborgen',         emoji: '🌹', beschreibung: 'Wohlig umhüllt, mit einem Hauch Sinnlichkeit' }
      ]
    },
    {
      id: 'koerper',
      frage: 'Wobei soll dich dein Öl begleiten?',
      subtitle: 'Wähle, was am besten passt.',
      optionen: [
        { value: 'Freies Durchatmen',      label: 'Freies Durchatmen',      emoji: '🌬️', beschreibung: 'Für Nase, Bronchien und tiefe Atemzüge' },
        { value: 'Haut & Schönheit',       label: 'Haut & Pflege',          emoji: '✨', beschreibung: 'Kleine Streicheleinheiten und zarte Zuwendung' },
        { value: 'Muskeln & Bewegung',     label: 'Muskeln & Bewegung',     emoji: '💪', beschreibung: 'Wohltuend nach Sport, Anstrengung und langen Tagen' },
        { value: 'Verdauung & Bauchgefühl', label: 'Bauch & Verdauung',      emoji: '🫚', beschreibung: 'Für ein wohliges, ausgeglichenes Gefühl nach dem Essen' },
        { value: 'Abwehr & Immunkraft',    label: 'Abwehr & Immunkraft',    emoji: '🛡️', beschreibung: 'Gut gewappnet durch die kalte Jahreszeit' },
        { value: 'Kreislauf & Venen',      label: 'Beine & Kreislauf',      emoji: '💓', beschreibung: 'Für angenehme Leichtigkeit und ein belebtes Gefühl' }
      ]
    }
  ];

  // Gewichte: Duft am stärksten (emotionalste Entscheidung), dann Seele/Körper.
  const WEIGHTS = { duft: 3, seele: 2, koerper: 2 };

  let PRODUCTS = [];
  let COLLECTION_URL = '/collections/all';
  let state = { currentStep: 0, answers: {} };

  // ── Daten aus der Section laden ───────────────────────────────────────────
  function loadProducts() {
    const el = document.getElementById('duftfinder-data');
    if (!el) return [];
    try {
      // verkaufsrang = Position in der Liste. Die Section rendert die Produkte in
      // Collection-Reihenfolge, und die Oel-Collection ist auf BEST_SELLING
      // sortiert — der Index ist damit der Verkaufsrang (0 = meistverkauft).
      // Wird nur innerhalb derselben Pflanze ausgewertet, siehe getTopResults.
      const pool = document.getElementById('duftfinder-pool');
      const karten = pool ? Array.from(pool.children) : [];
      const daten = JSON.parse(el.textContent) || [];
      // Karte i gehört zu Datensatz i (gleiche Schleife in der Section). Passt
      // die Anzahl nicht, lieber gar keine Karte zuordnen als eine falsche.
      const passt = karten.length === daten.length;
      return daten.map((p, i) => ({
        handle: p.handle,
        name: p.name || '',
        url: p.url || '#',
        karte: passt ? karten[i] : null,
        verkaufsrang: i,
        tags: { duft: p.duft || [], seele: p.seele || [], koerper: p.koerper || [] }
      }));
    } catch (e) {
      return [];
    }
  }

  // ── Scoring (weich) ───────────────────────────────────────────────────────
  function scoreProduct(product, answers) {
    return Object.keys(answers).reduce((total, key) => {
      const value = answers[key];
      if (!value) return total;
      return total + ((product.tags[key] || []).includes(value) ? WEIGHTS[key] : 0);
    }, 0);
  }

  // Trifft das Öl die gewählte Gefühls-Antwort (Seele)? Dient als Guardrail:
  // ein Seele-Treffer darf nie hinter ein nicht-passendes Öl rutschen, damit
  // z. B. „Energie" nie ein beruhigendes Öl an die Spitze stellt.
  function matchesSeele(product, answers) {
    const v = answers.seele;
    return !!v && (product.tags.seele || []).includes(v);
  }

  // Zweiter Guardrail, nur für „Haut & Pflege" (Endabnahme 2026-09-08): Wer
  // nach Hautpflege fragt, bekommt ein hautgeeignetes Öl zuerst — auch wenn
  // ein anderes über den Duft mehr Punkte hätte. Grund: Ölen wie Grapefruit
  // (phototoxisch) oder Gewürznelke (Eugenol, stark hautreizend) wurde dieser
  // Cluster in der Web-Gegenprüfung bewusst gestrichen; ohne die Regel standen
  // sie trotzdem als „Beste Empfehlung" über einem geeigneten Öl, weil
  // Duft + Gefühl (5 Punkte) schwerer wiegt als Gefühl + Körper (4).
  // Bewusst nur diese Kachel — Hautkontakt ist die Anwendung mit Risiko. Für
  // alle Körper-Kacheln gemessen wäre der Preis zu hoch (der Duft würde dann
  // in 42 statt in 6 Kombinationen ignoriert).
  const KACHEL_HAUT = 'Haut & Schönheit';
  function matchesHaut(product, answers) {
    return answers.koerper === KACHEL_HAUT
      && (product.tags.koerper || []).includes(KACHEL_HAUT);
  }

  // ── Gleichstand auflösen (Analyse 2026-09-07) ─────────────────────────────
  // Punkte und Guardrail allein trennen zu grob: in 124 von 216 Antwort-Kombis
  // teilen sich mehr als 3 Öle den Höchstwert, in 199 entscheidet der Gleichstand
  // den letzten Platz. Weil die Sortierung stabil ist, gewann bis hierhin die
  // Position in der Collection — inhaltlich beliebig, und immer dieselben Öle
  // (nur 48 von 130 konnten je sicher in die Top 3). Deshalb drei Kriterien:

  // 1. Archetyp: Das Öl steht in genau einer Duftfamilie, und zwar der gewählten.
  //    Ein Öl, das *nur* frisch ist, vertritt „Frisch & Klar" reiner als eines,
  //    das nebenbei auch würzig und holzig ist.
  function isArchetype(product, answers) {
    const d = product.tags.duft || [];
    return d.length === 1 && d[0] === answers.duft;
  }

  // 2. Fester Losentscheid (FNV-1a, 32 Bit) über Handle + Antwort-Kombination:
  //    verteilt die verbleibenden Gleichstände gleichmässig über den Katalog,
  //    bleibt aber reproduzierbar — gleiche Antworten liefern immer dasselbe
  //    Ergebnis, unabhängig von der Sortierung der Collection.
  function fnv1a(str) {
    let h = 0x811c9dc5;
    for (let i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = Math.imul(h, 0x01000193) >>> 0;
    }
    return h >>> 0;
  }

  function comboKey(answers) {
    return ['duft', 'seele', 'koerper'].map(k => answers[k] || '').join('|');
  }

  // 3. Keine Pflanze doppelt: erstes Wort des Produkttitels, am Bindestrich
  //    gekappt („Eukalyptus-globulus Bio 5 ml" → eukalyptus). Drei Lavendel als
  //    Ergebnis wirken wie ein Fehler, auch wenn alle drei perfekt passen.
  //    Die Shop-Titel sind gewachsen und nicht systematisch, deshalb ein paar
  //    Synonyme (Endabnahme 2026-09-08): sonst gälten „Lavandin super" und
  //    „Lavendel-fein" als verschiedene Pflanzen. Bewusst NICHT zusammengefasst
  //    ist „Majoran-spanisch" — in der Datenbank ein Thymian (Thymus mastichina),
  //    für den Kunden aber erkennbar ein Majoran.
  const FAMILIE_SYNONYM = {
    lavandin: 'lavendel', speiklavendel: 'lavendel',
    krauseminze: 'minze', nanaminze: 'minze', pfefferminze: 'minze',
    rosengeranium: 'geranium', bourbongeranium: 'geranium',
    blutorange: 'orange', weisstanne: 'tanne'
  };
  function familyOf(product) {
    const wort = String(product.name || '').split(' ')[0].split('-')[0].toLowerCase();
    return FAMILIE_SYNONYM[wort] || wort;
  }

  // Liefert bis zu n Öle: bevorzugt echte Treffer (Score > 0), sonst die
  // nächstliegenden (nach Mood-Guardrail + Score). So gibt es nie eine Sackgasse.
  // Über den vollen Katalog hat jede der 216 Kombis ≥55 Treffer (Fall „0 Treffer"
  // = strukturell unmöglich); der else-Zweig greift real nur bei dünnen Test-Daten.
  // Innerhalb einer Punktestufe gilt: erst Öle neuer Pflanzen, dann auffüllen —
  // die Familienregel darf nie einen besser passenden Treffer verdrängen.
  function getTopResults(answers, n) {
    const key = comboKey(answers);
    const ranked = PRODUCTS
      .map(p => ({
        p,
        score: scoreProduct(p, answers),
        seele: matchesSeele(p, answers),
        haut: matchesHaut(p, answers) ? 1 : 0,
        arch: isArchetype(p, answers) ? 1 : 0,
        lot: fnv1a(p.handle + '|' + key)
      }))
      .sort((a, b) => (b.seele - a.seele) || (b.haut - a.haut) || (b.score - a.score)
        || (b.arch - a.arch) || (a.lot - b.lot));
    const scored = ranked.filter(x => x.score > 0);
    const pool = scored.length ? scored : ranked;

    const chosen = [];
    const familien = new Set();
    let i = 0;
    while (i < pool.length && chosen.length < n) {
      // Gruppe = alle Öle derselben Punktestufe (gleiche Guardrails, gleiche Punkte)
      let j = i;
      while (j < pool.length && pool[j].seele === pool[i].seele
        && pool[j].haut === pool[i].haut && pool[j].score === pool[i].score) j++;
      const gruppe = pool.slice(i, j);

      // Je Pflanze zuerst die meistverkaufte Variante anbieten (Endabnahme
      // 2026-09-08): sonst gewinnt hier das Los, und der Bestseller verliert
      // gegen sein eigenes Nischen-Geschwister — Lavendel fein (Verkaufsrang 1)
      // stand nur in 3 seiner 8 perfekten Kombinationen, in 4 davon ein anderer
      // Lavendel. Der Verkaufsrang entscheidet bewusst NUR innerhalb einer
      // Pflanze; welche Pflanzen es ins Ergebnis schaffen, bleibt beim Los.
      const besteJeFamilie = new Map();
      gruppe.forEach(it => {
        const f = familyOf(it.p);
        const bisher = besteJeFamilie.get(f);
        if (!bisher || (it.p.verkaufsrang || 0) < (bisher.p.verkaufsrang || 0)) {
          besteJeFamilie.set(f, it);
        }
      });
      const zuerst = gruppe.filter(it => besteJeFamilie.get(familyOf(it.p)) === it);
      const danach = gruppe.filter(it => besteJeFamilie.get(familyOf(it.p)) !== it);

      zuerst.forEach(it => {
        if (chosen.length < n && !familien.has(familyOf(it.p))) {
          chosen.push(it);
          familien.add(familyOf(it.p));
        }
      });
      zuerst.concat(danach).forEach(it => {
        if (chosen.length < n && chosen.indexOf(it) === -1) {
          chosen.push(it);
          familien.add(familyOf(it.p));
        }
      });
      i = j;
    }
    return chosen;
  }

  function maxScore() {
    return Object.keys(state.answers).reduce((s, k) => s + (state.answers[k] ? WEIGHTS[k] : 0), 0);
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, c =>
      ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  // ── Rendering: Schritt ────────────────────────────────────────────────────
  function renderStep() {
    const step = QUIZ_STEPS[state.currentStep];
    const total = QUIZ_STEPS.length;
    const quiz = document.getElementById('duftfinder-quiz');
    if (!quiz) return;

    const dots = Array.from({ length: total }, (_, i) =>
      `<span class="finder-dot ${i === state.currentStep ? 'finder-dot--active' : i < state.currentStep ? 'finder-dot--done' : ''}"></span>`
    ).join('');

    const current = state.answers[step.id];

    const optionen = step.optionen.map(opt => `
      <button class="finder-option ${current === opt.value ? 'is-selected' : ''}"
              data-value="${escapeHtml(opt.value)}" aria-pressed="${current === opt.value}">
        <span class="finder-option__emoji" aria-hidden="true">${opt.emoji}</span>
        <span class="finder-option__label">${escapeHtml(opt.label)}</span>
        <span class="finder-option__desc">${escapeHtml(opt.beschreibung)}</span>
      </button>
    `).join('');

    quiz.innerHTML = `
      <div class="finder-step">
        <div class="finder-progress">
          ${dots}
          <span class="finder-progress__text">Schritt ${state.currentStep + 1} von ${total}</span>
        </div>
        <h2 class="finder-step__frage">${escapeHtml(step.frage)}</h2>
        <p class="finder-step__subtitle">${escapeHtml(step.subtitle)}</p>
        <div class="finder-options">${optionen}</div>
        ${state.currentStep > 0 ? `
        <div class="finder-nav">
          <button class="btn btn--ghost btn--sm" id="btn-back">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
            Zurück
          </button>
        </div>` : ''}
      </div>
    `;

    quiz.querySelectorAll('.finder-option').forEach(btn => {
      btn.addEventListener('click', () => {
        state.answers[step.id] = btn.dataset.value;
        btn.closest('.finder-options').querySelectorAll('.finder-option').forEach(b => {
          b.classList.toggle('is-selected', b === btn);
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        setTimeout(() => {
          if (state.currentStep === total - 1) renderResults();
          else { state.currentStep++; renderStep(); }
        }, 220);
      });
    });

    const back = document.getElementById('btn-back');
    if (back) back.addEventListener('click', () => { state.currentStep--; renderStep(); });
  }

  // ── Rendering: Ergebnis ───────────────────────────────────────────────────
  // Symbol des Knopfs «Nochmal starten» (Ergebnis und Fall ohne Öle).
  const ICON_RESTART = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M1 4v6h6M23 20v-6h-6"/><path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4-4.64 4.36A9 9 0 0 1 3.51 15"/></svg>';

  // Treffer-Karten zurück in den versteckten Vorrat legen, Badge entfernen und
  // das Ergebnis-Raster leeren. Muss vor jedem neuen Rendern laufen — sonst
  // würde innerHTML die verschobenen Karten (samt Warenkorb-Handlern) zerstören.
  function clearResults() {
    const box = document.getElementById('duftfinder-ergebnis');
    const pool = document.getElementById('duftfinder-pool');
    if (!box) return;
    if (pool) {
      box.querySelectorAll('.product-card').forEach(card => {
        const badge = card.querySelector('[data-finder-badge]');
        if (badge) badge.remove();
        pool.appendChild(card);
      });
    }
    box.innerHTML = '';
    box.hidden = true;
  }

  function renderResults() {
    const quiz = document.getElementById('duftfinder-quiz');
    const box = document.getElementById('duftfinder-ergebnis');
    if (!quiz) return;
    clearResults();
    // Nur Treffer mit vorgerenderter Karte (fehlt der Vorrat, greift der Fall unten).
    // 4 Treffer (Marc 2026-10-19): am Handy 2 × 2, ab Tablet eine Reihe.
    const results = box ? getTopResults(state.answers, 4).filter(r => r.p.karte) : [];

    // Greift nur, wenn gar keine Öle geladen sind (Collection leer/falsch
    // konfiguriert) – kein Nutzer-Auswahl-Fall, daher neutrale Stöber-Einladung.
    if (results.length === 0) {
      quiz.innerHTML = `
        <div class="finder-results">
          <div class="finder-results__header">
            <p class="eyebrow">Unsere Öle</p>
            <h2>Entdecke unsere ätherischen Öle</h2>
            <p class="finder-step__subtitle" style="text-align:center;">Stöbere durch unsere Auswahl und finde dein Lieblingsöl.</p>
          </div>
          <div class="finder-results__actions">
            <a href="${escapeHtml(COLLECTION_URL)}" class="btn btn--primary btn--sm">
              Alle Öle entdecken
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
            </a>
            <button class="btn btn--primary btn--sm btn--pill" id="btn-restart">
              ${ICON_RESTART}
              Nochmal starten
            </button>
          </div>
        </div>`;
      document.getElementById('btn-restart').addEventListener('click', resetQuiz);
      return;
    }

    // Überschrift bleibt ehrlich abgestuft, wenn kein 3-fach-Treffer dabei ist.
    // Den früheren Zusatz „Kein exaktes Match" gibt es nicht mehr (Entscheid
    // Marc 2026-09-08): er stand in 49 der 216 Kombinationen direkt neben dem
    // Badge „Beste Empfehlung" und widersprach ihm.
    const perfect = results[0].score === maxScore();
    const headline = perfect
      ? 'Passend zu deiner Auswahl'
      : 'Diese Öle passen am ehesten zu dir';

    // Überschrift im schmalen Quiz (aria-live: wird angesagt), Karten und Knopf
    // im breiten Ergebnis-Raster darunter — gleiche Breite wie die Collection-Seite.
    quiz.innerHTML = `
      <div class="finder-results">
        <div class="finder-results__header">
          <p class="eyebrow">Unsere Empfehlung</p>
          <h2>${headline}</h2>
        </div>
      </div>
    `;
    box.innerHTML = `
      <div class="finder-results">
        <div class="product-grid"></div>
        <div class="finder-results__actions">
          <button class="btn btn--primary btn--sm btn--pill" id="btn-restart">
            ${ICON_RESTART}
            Nochmal starten
          </button>
        </div>
      </div>
    `;
    const grid = box.querySelector('.product-grid');
    results.forEach((r, i) => {
      const card = r.p.karte;
      // Der Einblend-Beobachter aus main.js kennt nur Karten, die beim Laden
      // sichtbar waren — hier gleich als eingeblendet markieren.
      card.classList.add('visible');
      if (i === 0) {
        const wrap = card.querySelector('.product-card__image-wrap');
        if (wrap) {
          wrap.insertAdjacentHTML('afterbegin',
            '<span class="badge badge--primary badge--sm" data-finder-badge style="position:absolute;top:var(--space-3);left:var(--space-3);z-index:1;">Empfehlung</span>');
        }
      }
      grid.appendChild(card);
    });
    box.hidden = false;
    document.getElementById('btn-restart').addEventListener('click', resetQuiz);
  }

  function resetQuiz() {
    state = { currentStep: 0, answers: {} };
    clearResults();
    renderStep();
    const sec = document.getElementById('finder-section');
    if (sec) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ── Init ──────────────────────────────────────────────────────────────────
  function init() {
    const quiz = document.getElementById('duftfinder-quiz');
    if (!quiz) return;
    PRODUCTS = loadProducts();
    COLLECTION_URL = quiz.dataset.collectionUrl || COLLECTION_URL;

    // Hero-Button startet das Quiz neu (nicht nur scrollen): nach einem
    // Ergebnis führt er wieder zu Frage 1. Der Öl-Zähler im Hero kommt aus
    // der Section (Collection-Zähler in Liquid), nicht mehr aus den Quiz-Daten.
    const btnStart = document.getElementById('btn-start-hero');
    if (btnStart) btnStart.addEventListener('click', resetQuiz);

    state.currentStep = 0;
    renderStep();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
